import { useSearchParams } from 'react-router-dom';
import { Box, Divider, Skeleton, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { readPlanParam } from '../../../../../shared/helpers/functions/navigation';
import {
  Plan,
  planToI18nKey,
} from '../../../../../shared/helpers/constants/plans';
import rootStore from '../../../rootStore/RootStore';
import useStripeSubscriptionPreview from '../../../subscriptionPreview/hooks/useStripeSubscriptionPreview';
import { getSubscriptionPreviewPeriod } from '../../../subscriptionPreview/helpers/functions/preview';

const PlanPeriod = observer(() => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const plan = readPlanParam(searchParams) as Plan;
  const { subscriptionPreviewStore } = rootStore;
  const {
    subscriptionPreviewGenerated: isPreviewGenerated,
    subscriptionPreviewError: isPreviewError,
  } = subscriptionPreviewStore;
  const { preview } = useStripeSubscriptionPreview();
  const { start, end } = getSubscriptionPreviewPeriod(preview);

  let periodLabel;
  let renewalPeriod;

  if (plan === Plan.annual) {
    renewalPeriod = t('checkout.renewal-period.year');
  } else if (plan === Plan.monthly) {
    renewalPeriod = t('checkout.renewal-period.month');
  }

  if (isPreviewGenerated) {
    periodLabel = (
      <Typography>
        {t('checkout.plan-period', { start, end, renewalPeriod })}
      </Typography>
    );
  } else if (!isPreviewGenerated && !isPreviewError) {
    periodLabel = <Skeleton variant="text" width={200} />;
  } else {
    periodLabel = null;
  }

  return (
    <Box>
      <Typography variant="body2">{t(planToI18nKey[plan])}</Typography>
      {periodLabel}
      <Divider sx={{ mt: 2 }} />
    </Box>
  );
});

export default PlanPeriod;
